module.exports = __webpack_public_path__ + "static/media/tickWithWhiteBg.04609fce.png";